@if (component && componentType) {
<div class="tw-h-full tw-flex tw-flex-col">
  <div class="tw-pb-4 tw-border-b tw-border-gray-200 tw-mb-5">
    <h4 class="tw-m-0 tw-mb-1 tw-text-base tw-font-semibold tw-text-gray-800">{{ componentType.name }}</h4>
    <p class="tw-m-0 tw-text-xs tw-text-gray-500 tw-leading-relaxed">{{ componentType.description }}</p>
  </div>

  <form [formGroup]="propertiesForm" class="tw-flex-1 tw-overflow-y-auto">
    <div class="tw-mb-5" *ngFor="let variable of componentType.variables">
      <label class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-2">
        {{ variable.label }}
        <span class="tw-text-red-500 tw-ml-0.5" *ngIf="variable.is_required">*</span>
      </label>

      <!-- Text/HTML Input -->
      <div *ngIf="isTextArea(variable.type)" class="tw-mb-2">
        <textarea
          [formControlName]="variable.name"
          [placeholder]="variable.default_value || 'Enter ' + variable.label.toLowerCase()"
          rows="3"
          class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-rounded-md tw-resize-y tw-min-h-[60px] focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-transparent"
        ></textarea>
      </div>

      <!-- Color Picker -->
      <div class="md:tw-flex md:tw-items-center md:tw-gap-2 tw-flex-col tw-items-stretch" *ngIf="isColorPicker(variable.type)">
        <input
          type="color"
          [formControlName]="variable.name"
          [value]="getVariableValue(variable.name)"
          class="tw-w-12 tw-h-10 tw-p-0 tw-border-none tw-rounded tw-cursor-pointer"
        />
        <span class="sm:tw-text-center tw-text-xs tw-text-gray-500 tw-bg-gray-50 tw-px-2 tw-py-1 tw-rounded tw-border tw-border-gray-200">{{
          getVariableValue(variable.name)
        }}</span>
      </div>

      <!-- Regular Input (text, url, number) -->
      <div *ngIf="!isTextArea(variable.type) && !isColorPicker(variable.type)" class="tw-mb-2">
        <input
          [type]="getVariableInputType(variable.type)"
          [formControlName]="variable.name"
          [placeholder]="variable.default_value || 'Enter ' + variable.label.toLowerCase()"
          class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-rounded-md focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-transparent"
        />
      </div>

      <!-- Validation Rules Info -->
      <div class="tw-mt-1" *ngIf="variable.validation_rules && variable.validation_rules.length > 0">
        <small class="tw-text-xs tw-text-gray-500 tw-italic">
          <span *ngFor="let rule of variable.validation_rules; let last = last"> {{ formatValidationRule(rule) }}<span *ngIf="!last">, </span> </span>
        </small>
      </div>
    </div>
  </form>
</div>

<div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-text-center tw-text-gray-500 tw-p-10" *ngIf="!component">
  <svg viewBox="0 0 24 24" class="tw-text-3xl tw-mb-3 tw-opacity-50">
    <path
      d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.22,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"
    />
  </svg>
  <p class="tw-m-0 tw-text-sm">Select a component to edit its properties</p>
</div>
} @else {
<div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-text-center tw-text-gray-500 tw-p-10">
  <svg viewBox="0 0 24 24" class="tw-text-3xl tw-mb-3 tw-opacity-50">
    <path
      d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.22,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"
    />
  </svg>
  <p class="tw-m-0 tw-text-sm">Select a component to edit its properties</p>
</div>
}
